






























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Axios from 'axios';
import { accountingSheet } from '@/utils/config';
import { FormationStatusApiResponse } from '@/types/formationStatus';

@Component
export default class FormationStatusDrawer extends Vue {
  @Prop({ default: null }) readonly jbpmProcessId!: number | null;

  open = false;

  loading = false;

  showDetails = false;

  status: FormationStatusApiResponse | null = null;

  loadError: string | null = null;

  get alertType(): string {
    if (!this.status) {
      return 'info';
    }
    if (this.status.status === 'failed') {
      return 'error';
    }
    if (this.status.status === 'completed') {
      return 'success';
    }
    return 'info';
  }

  get statusText(): string {
    if (!this.status) {
      return '';
    }
    if (this.status.status === 'failed') {
      return this.$t('formation_status_drawer_failed') as string;
    }
    if (this.status.status === 'completed') {
      return this.$t('formation_status_drawer_completed') as string;
    }
    return this.$t('formation_sheet_pending') as string;
  }

  get errorDetailsText(): string {
    if (!this.status) {
      return '';
    }
    return this.status.error_details || this.status.error_trace || this.status.error_message || '';
  }

  openDrawer(): void {
    this.open = true;
    if (!this.status && !this.loading) {
      this.loadStatus();
    }
  }

  async loadStatus(): Promise<void> {
    if (!this.jbpmProcessId) {
      return;
    }
    this.loading = true;
    this.loadError = null;
    try {
      const response = await Axios.get<FormationStatusApiResponse>(
        accountingSheet.formationStatus,
        { params: { jbpmProcessId: this.jbpmProcessId } },
      );
      this.status = response.data;
    } catch (e) {
      const axiosError = e as { response?: { data?: unknown }; message?: string };
      const responseData = axiosError.response?.data;
      this.loadError = typeof responseData === 'string'
        ? responseData
        : JSON.stringify(responseData ?? axiosError.message ?? e, null, 2);
    } finally {
      this.loading = false;
    }
  }

  copyError(): void {
    const text = this.errorDetailsText
      + (this.jbpmProcessId ? `\n\n${this.$t('formation_sheet_process_id', { id: this.jbpmProcessId })}` : '');
    navigator.clipboard.writeText(text);
  }
}
